import { Routes } from '@angular/router';
import { Layouts } from './layouts/layouts';
import { UserRole } from './shared/model/role';
import { canMatchGuard } from './core/guards/can-match-guard';
import { authGuard } from './core/guards/auth-guard';
import { roleParamGuard } from './core/guards/role-param-guard';
import { Login } from './pages/login/login';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  { path: 'login', component: Login },

  {
    path: '',
    component: Layouts,
    canActivate: [authGuard],
    children: [
      // The old mock "Package Overview" page is replaced by the real Packages inventory.
      { path: ':role/package', redirectTo: ':role/packages', pathMatch: 'full' },
      // {
      //   path: ':role/packages',
      //   loadComponent: () =>
      //     import('./pages/packages/packages').then(m => m.Packages),
      //   title: 'Packages | Pexlens'
      // },
      // {
      //   path: ':role/packages/devices',
      //   loadComponent: () =>
      //     import('./pages/packages/package-devices/package-devices').then(m => m.PackageDevices),
      //   title: 'Package devices | Pexlens'
      // },
      // {
      //   path: ':role/threats',
      //   loadComponent: () =>
      //     import('./pages/threats/threats').then(m => m.Threats),
      //   title: 'Threats | Pexlens'
      // },

      // {
      //   path: ':role/scanHistory',
      //   loadChildren: () =>
      //     import('./pages/scan-history/scan-history-routing-module').then(m => m.ScanHistoryRoutingModule),
      //   title: 'Scan History | Pexlens'
      // },
      // {
      //   path: ':role/deploymentKeys',
      //   loadComponent: () =>
      //     import('./pages/deployment-keys/deployment-keys').then(m => m.DeploymentKeys),
      //   title: 'Deployment Keys | Pexlens'
      // },
      // {
      //   path: ':role/downloadLogs',
      //   loadComponent: () =>
      //     import('./pages/download-logs/download-logs').then(m => m.DownloadLogs),
      //   title: 'Download Logs | Pexlens'
      // },

      // {
      //   path: ':role/devices',
      //   loadComponent: () =>
      //     import('./pages/devices/devices').then(m => m.Devices),
      //   title: 'Devices | Pexlens'
      // },

      // {
      //   path: ':role/repositories',
      //   loadChildren: () =>
      //     import('./pages/repositories/repository-routing-module').then(m => m.RepositoryRoutingModule),
      //   title: 'Repositories | Pexlens'
      // },

      // {
      //   path: ':role/auditLogs',
      //   loadComponent: () =>
      //     import('./pages/audit-log/audit-log').then(m => m.AuditLog),
      //   title: 'Audit Logs | Pexlens'
      // },

      // {
      //   path: ':role/teams',
      //   loadChildren: () =>
      //     import('./pages/teams/teams-routing-module').then(m => m.TeamsRoutingModule),
      //   title: 'Teams | Pexlens'
      // },

      // {
      //   path: ':role/users',
      //   loadComponent: () =>
      //     import('./pages/active-user/active-user').then(m => m.ActiveUser),
      //   title: 'Users | Pexlens'
      // },

      { path: ':role/package/:ecosystem/:packageName', redirectTo: ':role/packages' },

      // {
      //   path: 'user',
      //   canMatch: [canMatchGuard],
      //   data: { role: UserRole.USER },
      //   loadChildren: () =>
      //     import('./pages/user/user.routing').then(m => m.routes)
      // },

      {
        path: 'superAdmin',
        canMatch: [canMatchGuard],
        data: {
          roles: [UserRole.SUPERADMIN]
        },
        loadChildren: () =>
          import('./pages/super-admin/super-admin.routing').then(m => m.routes)
      },

      {
        path: 'admin',
        canMatch: [canMatchGuard],
        data: {
          roles: [UserRole.ADMIN]
        },
        loadChildren: () =>
          import('./pages/user-management/user-management.routing').then(m => m.routes)
      },
      {
        path: 'teamManager',
        canMatch: [canMatchGuard],
        data: {
          roles: [UserRole.TEAMMANAGER]
        },
        loadChildren: () =>
          import('./pages/user-management/user-management.routing').then(m => m.routes)
      },

      {
        path: 'user',
        canMatch: [canMatchGuard],
        data: {
          roles: [UserRole.USER]
        },
        loadChildren: () =>
          import('./pages/user-management/user-management.routing').then(m => m.routes)
      },

      {
        path: 'viewer',
        canMatch: [canMatchGuard],
        data: {
          roles: [UserRole.VIEWER]
        },
        loadChildren: () =>
          import('./pages/user-management/user-management.routing').then(m => m.routes)
      },

      // {
      //   path: ':role/package/:ecosystem/:packageName',
      //   canActivate: [roleParamGuard],
      //   loadComponent: () =>
      //     import('./pages/security/package-overview/package-overview').then(m => m.PackageOverview),
      //   title: 'Package Overview | Pexlens'
      // },

      { path: ':role/profile-detail', canActivate: [roleParamGuard], loadComponent: () => import("./pages/profile-detail/profile-detail").then(m => m.ProfileDetail) },

    ]
  },

  { path: 'reset-password', loadComponent: () => import("./pages/reset-password/reset-password").then(m => m.ResetPassword) },

  { path: '**', loadComponent: () => import('./pages/not-found/not-found').then(m => m.NotFound) }
];
